import React, { useRef, useState } from 'react';
// import PropTypes, { string } from 'prop-types';
import './index.scss';
import {
  CnInputGroup,
  CnAsyncSelect,
  CnIcon,
  CnImageViewer,
  CnInput,
  CnMessage,
  value,
} from '@alife/cn-ui';
import { formilyReact } from '@alife/cn-ui';
const { useField } = formilyReact;
import { showMultiItemsDialog } from './view';
import request from './view/request';

export default function MultiItems(props) {
  const {
    validateWhenOnblur,
    queryItemInfoParams,
    isMultiItemsParam,
    queryItemInfoURL,
    paramsListStructure,
    scene,
    onOk,
    handleIsNotMultiItems,
    ...rest
  } = props;

  const field = useField?.();

  const onBlur = (val) => {
    const blurValue = val?.target?.value;
    // window.WMS_BIZ_INPUT_VALUE = value;
    if (!val?.target?.value) CnMessage.warning('请输入商品条码');
    if (validateWhenOnblur) {
      // 先校验，校验通过再继续执行
      const continueFlag = validateWhenOnblur(val?.target?.value, field);
      if (!continueFlag) return;
    }

    request({
      url: queryItemInfoURL,
      method: 'post',
      data: { data: queryItemInfoParams(val?.target?.value, field) },
    }).then((res) => {
      const isMultiItems = isMultiItemsParam()?.reduce((k1, k2) => {
        return k1?.[k2];
      }, res?.data);
      const paramsList = paramsListStructure()?.reduce((k1, k2) => {
        return k1?.[k2];
      }, res?.data);

      // 不是一码多品
      if (!isMultiItems) {
        handleIsNotMultiItems &&
          handleIsNotMultiItems(blurValue, field, res?.data);
        return;
      }

      // 是一码多品
      showMultiItemsDialog({
        scene,
        paramsList,
        itemBarCode: val?.target?.value,
        onOk: (rowData) => {
          onOk && onOk(blurValue, rowData, field);
        },
        onCancel: () => {},
        tableProps: {
          fixedHeader: false,
        },
      });
    });
  };

  return <CnInput {...rest} onBlur={onBlur} />;
}

export { MultiItems };

MultiItems.displayName = 'MultiItems';

MultiItems.propTypes = {
  // children: PropTypes.node,
  // type: string,
};

MultiItems.defaultProps = {
  // children: null,
  value: '',
  onChange: () => {},
  // type: 'select',
};
